module.exports = __webpack_public_path__ + "static/media/Rectangle 12894.7a0cf8d3.png";